import React from 'react';

const MaintenancePage = () => {
    const styles = {
        page: {
            minHeight: '100vh',
            background: '#f8f9fa',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
        },
        card: {
            background: 'white',
            borderRadius: '4px',
            padding: '40px 30px',
            maxWidth: '500px',
            width: '100%',
            textAlign: 'center',
        },
        iconWrapper: {
            width: '80px',
            height: '80px',
            margin: '0 auto 25px',
            background: '#6c757d',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        title: {
            fontSize: '1.75rem',
            fontWeight: '500',
            color: '#333',
            marginBottom: '15px',
            marginTop: '0',
        },
        description: {
            fontSize: '1rem',
            color: '#666',
            lineHeight: '1.6',
            marginBottom: '0',
        },
        footer: {
            marginTop: '30px',
            paddingTop: '20px',
            borderTop: '1px solid #f0f0f0',
        },
        footerText: {
            color: '#999',
            fontSize: '0.85rem',
            margin: 0,
        },
    };

    return (
        <div style={styles.page}>
            <div style={styles.card}>
                {/* Icon */}
                <div style={styles.iconWrapper}>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="white">
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
                    </svg>
                </div>

                <h1 style={styles.title}>System Update in Progress</h1>
                <p style={styles.description}>
                    We&apos;re currently performing scheduled maintenance.
                    Thank you for your patience, we&apos;ll be back shortly.
                </p>

                <div style={styles.footer}>
                    <p style={styles.footerText}>
                        For urgent matters, please contact support
                    </p>
                </div>
            </div>
        </div>
    );
};

export default MaintenancePage;
